class GoogleMaps {
    constructor() {
        this._init()
    }
    _init() {

        this.el = document.querySelector('[map-display]')
		if(!this.el) {
			return
		}

        // Create the script tag, set the appropriate attributes
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBwdiS4narJi70Can24-uvoEfmbFPdtp_Q&callback=initMap';
        script.defer = true;
        script.async = true;

        // Attach your callback function to the `window` object
        window.initMap = function() {
        // JS API is loaded and available
            var companyLatLng = {lat: 41.509955, lng: -8.470462};
           
            var map = new google.maps.Map(document.getElementById("map"), {
                center: companyLatLng,
                zoom: 15
            });

            var marker = new google.maps.Marker({
                position: companyLatLng,
                title: 'Qualimóvel',
                visible: true
            });


            marker.setMap(map);
        };
        // Append the 'script' element to 'head'
        document.head.appendChild(script);
    }
}
export default GoogleMaps